// 고객사 리포트 / 고장 조치 이력 — 한 화면의 두 탭.
//
// 사이드바 항목은 '고객사 리포트' 하나뿐이고, 조치 이력은 그 안의 탭이다
// (오너 결정 2026-09-14). 신고를 보고 나서 "그래서 뭘 했나" 를 찾는 흐름이라
// 메뉴를 오갈 일이 아니라 한 화면 안에서 넘기는 게 맞다.
//
// 탭이지만 **라우트는 둘로 유지한다.** 상태로만 바꾸면 주소가 안 변해서
// 링크로 공유할 수 없고, 브라우저 뒤로가기가 탭을 되돌리지 못한다.
//
// 모양·키보드 동작은 저장소 선례(CustomerDocumentsPage 의 국내/해외 탭)를 따른다.

import { useLocation, useNavigate } from 'react-router-dom';
import type { CSSProperties } from 'react';

const TABS = [
  { key: 'reports', to: '/field/customer-reports', label: '고객사 리포트' },
  { key: 'remediations', to: '/field/fault-remediations', label: '고장 조치 이력' },
] as const;

/**
 * 두 탭 화면의 바깥 틀. 위 여백은 0 이고 위로 12px 당겨서, 레이아웃 여백 24px 중 12px 만 남긴다.
 * 탭 위가 비어 보였다(2026-10-28 오너 "간격을 많이 줄이거나").
 */
export const fieldReportPage: CSSProperties = {
  padding: '0 28px 24px',
  marginTop: -12,
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
};

const tabList: CSSProperties = {
  display: 'flex',
  gap: 4,
  borderBottom: '1px solid var(--border-subtle)',
};

export function FieldReportTabs() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  function onKeyDown(e: React.KeyboardEvent, idx: number) {
    let next: number | null = null;
    if (e.key === 'ArrowRight') next = (idx + 1) % TABS.length;
    else if (e.key === 'ArrowLeft') next = (idx - 1 + TABS.length) % TABS.length;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = TABS.length - 1;
    if (next === null) return;
    e.preventDefault();
    document.getElementById(`field-report-tab-${TABS[next].key}`)?.focus();
  }

  return (
    <div role="tablist" aria-label="고객사 리포트와 고장 조치 이력" style={tabList}>
      {TABS.map((t, i) => {
        const active = pathname === t.to;
        return (
          <button
            key={t.key}
            type="button"
            role="tab"
            id={`field-report-tab-${t.key}`}
            aria-selected={active}
            tabIndex={active ? 0 : -1}
            onClick={() => !active && navigate(t.to)}
            onKeyDown={(e) => onKeyDown(e, i)}
            style={{
              padding: '8px 14px',
              border: 'none',
              background: 'transparent',
              fontSize: 15,
              fontWeight: active ? 700 : 500,
              color: active ? 'var(--fg-brand)' : 'var(--fg-muted)',
              borderBottom: `2px solid ${active ? 'var(--brand)' : 'transparent'}`,
              cursor: active ? 'default' : 'pointer',
              marginBottom: -1,
            }}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
